export default "__VITE_ASSET__JiX0ZUbb__"